import {inject, Injectable}                 from '@angular/core';
import {Timestamp}                          from '@angular/fire/firestore';
import {BodyRecordLogIntf, BodySymptomType} from '@djsharkk/logr-types';
import {AuthUnlockService}                  from '../../../../../../../logr-auth/utils/auth-unlock.service';
import {MenuCrudPanelToggleBase}            from '../../menu-crud-panel-toggle-base';

@Injectable({
				providedIn: 'root'
			})
export class MenuCrudPanelBodyService extends MenuCrudPanelToggleBase<BodySymptomType> {
	svcAuthUnlock = inject(AuthUnlockService)

	selected: BodySymptomType[] = []
	note: string = '';

	constructor() {
		super('body')
	}

	async addRecord() {
		const note = await this.svcAuthUnlock.encrypt(this.note);
		const body = await Promise.all(this.selected.map(async (s) => {
			return this.svcAuthUnlock.encrypt(s); // Process each `s` into a string
		})) as BodySymptomType[];
		const record: BodyRecordLogIntf = {
			timestamp: Timestamp.now(),
			body,
			note
		};
		this.svcDataFactory.svcDataBody.createRecord(record)
	}
}
